module.exports = function incorrectDataType(value, type) {
  return typeof value !== type;
};
